import { styled } from '@/stitches.config';

const cellStyles = {
  fontSize: '$normal',
  lineHeight: '$4',
  padding: '$4 $0',
  textAlign: 'left',
  '&:first-child': {
    paddingLeft: '$8',
  },
  '&:last-child': {
    paddingRight: '$8',
  },
};

export const TableCellStyled = styled('td', {
  ...cellStyles,
  borderBottom: '$borderWidths$1 solid $colors$coolGray200',
  fontWeight: '$regular',
  fontSize: '$4',
  lineHeight: '$6',
  '&.borderless': {
    borderBottom: 'none',
    width: '$0',
  },
  'tr:last-child &': {
    borderBottom: '$0',
  },
});

export const TableHeadCellStyled = styled('th', {
  ...cellStyles,
  fontWeight: '$bold',
});
